import { useEffect, useState } from 'react'

type ConsentState = {
  analytics: boolean
  advertisement: boolean
  functional: boolean
}

const defaultConsent: ConsentState = {
  analytics: false,
  advertisement: false,
  functional: false,
}

function parseConsentFromEvent(detail: any): ConsentState {
  if (detail?.categories) {
    return {
      analytics: !!detail.categories.analytics,
      advertisement: !!detail.categories.advertisement,
      functional: !!detail.categories.functional,
    }
  }
  if (detail?.accepted) {
    return {
      analytics: detail.accepted.includes('analytics'),
      advertisement: detail.accepted.includes('advertisement'),
      functional: detail.accepted.includes('functional'),
    }
  }
  return defaultConsent
}

export function useCookieConsent(): ConsentState {
  const [consent, setConsent] = useState<ConsentState>(defaultConsent)

  useEffect(() => {
    const handleConsent = (event: Event) => {
      setConsent(parseConsentFromEvent((event as CustomEvent).detail))
    }

    document.addEventListener('cookieyes_banner_load', handleConsent)
    document.addEventListener('cookieyes_consent_update', handleConsent)

    return () => {
      document.removeEventListener('cookieyes_banner_load', handleConsent)
      document.removeEventListener('cookieyes_consent_update', handleConsent)
    }
  }, [])

  return consent
}
